import {
    setRawMaterials,
    addRawMaterial,
    updateRawMaterial,
    deleteRawMaterial,
    setLoading
} from "./rawMaterialSlice";

import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";

export const fetchAllRawMaterialAction = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));

        const cleanParams =
            Object.fromEntries(
                Object.entries(params)
                    .filter(([_, value]) => value !== "")
            );


        const query =
            new URLSearchParams(cleanParams).toString();

        const response = await getMethod(
            `/raw-material/list?${query}`
        );

        dispatch(setRawMaterials({data: response?.materials}));
        dispatch(setLoading(false));

        return response;
    } catch (error) {
        dispatch(setLoading(false));
        return { success: false, message: error };
    }
};

export const createRawMaterialAction = (data) => async (dispatch) => {
    try {
        const response = await postMethod(`/raw-material`, data);

        if (response?.data) {
            dispatch(addRawMaterial(response.data));
        }

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const updateRawMaterialAction = (id, data) => async (dispatch) => {
    try {
        const response = await putMethod(`/raw-material/${id}`, data);

        if (response?.data) {
            dispatch(updateRawMaterial(response.data));
        }

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};

export const deleteRawMaterialAction = (id) => async (dispatch) => {
    try {
        const response = await deleteMethod(`/raw-material/${id}`);

        dispatch(deleteRawMaterial(id));

        return response;
    } catch (error) {
        return { success: false, message: error };
    }
};
